var React = require('react');

function LogoBlack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20zM24.34 30.3c-.03.298.148.447.445.447h3.834c.297 0 .446-.149.446-.446v-7.52c0-.297-.178-.445-.446-.445h-4.428c-.268 0-.446.148-.446.445v.506s-.595 2.764-4.012 2.764c-1.279 0-2.14-.684-2.14-1.575 0-2.616 11.056-1.487 11.056-8.739 0-3.804-2.764-6.509-7.252-6.509-2.467 0-4.102.744-5.142 1.784l.119-1.16c.03-.297-.149-.445-.446-.445h-3.834c-.297 0-.446.148-.446.446v7.519c0 .297.178.446.446.446h4.429c.267 0 .445-.149.445-.446v-.475c0-1.19 1.1-2.646 3.627-2.646 1.337 0 2.11.565 2.11 1.486 0 3.24-11.77 1.605-11.77 8.917 0 3.12 2.11 6.3 7.311 6.3 3.953 0 6.093-2.11 6.153-2.11l-.06 1.457z"}));
}

LogoBlack.defaultProps = {"viewBox":"0 0 40 40"};

module.exports = LogoBlack;

LogoBlack.default = LogoBlack;
